import e from "../../utils/classNames.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItemIcon.tsx
var r = t((t, r) => {
	let { className: i, children: a, ...o } = t, s = e("ActionBarItemIcon", i);
	return /* @__PURE__ */ n("div", {
		...o,
		className: s,
		ref: r,
		children: a
	});
});
r.displayName = "ActionBarItemIcon";
//#endregion
export { r as default };

//# sourceMappingURL=ActionBarItemIcon.js.map